export const FINANCE_FILE_EXPORTS_LINK = {
  SUGGEST_SYSTEM: 'https://goodhuman.zendesk.com/hc/en-au/requests/new',
};

export enum ExportFileConfigType {
  ACCOUNT_SYSTEM = 'ACCOUNT_SYSTEM',
  PAYROLL_SYSTEM = 'PAYROLL_SYSTEM',
}
